// DS: i1.2
import React from 'react';
import cn from 'classnames';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import s from './CoreStar.scss';
const CoreStar = ({ className , size , customSize , corePackage ='core_access' , useSecondaryColor , useGradient ,  })=>{
    const uniqueId = useUniqueId();
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], useGradient ? s['gradient'] : useSecondaryColor ? s['secondary-color'] : s[corePackage], size && !customSize && s[`size-${size}`], className),
        style: customSize
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 15"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 7.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z",
        className: s['fill-color'],
        fill: useGradient ? `url(#${uniqueId})` : undefined
    }), /*#__PURE__*/ React.createElement("path", {
        className: s['bg-color'],
        d: "m7.5 2.778 1.26 2.796 2.967.37-2.19 2.1.575 3.025L7.5 9.57l-2.612 1.5.575-3.026-2.19-2.1 2.968-.37L7.5 2.778Z"
    }), useGradient && /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: uniqueId,
        x1: "15",
        y1: "0",
        x2: "-8.34465e-07",
        y2: "15",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF7663"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.739583",
        stopColor: "#F8BC76"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFB35C"
    })))));
};
CoreStar.displayName = 'CoreStar';
export default CoreStar;
